import { connect } from 'react-redux';
import { getLoader } from '../../../store/loader/selectors';
import Loader from './Loader';

const mapStateToProps = (state, ownProps) => ({
  loader: getLoader(state),
  ownProps,
});

export default connect(mapStateToProps)(Loader);
